import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Card from '../../../Components/Card/Index.js'
import CardMeeting from '../../../Components/Card/MeetingCard.js'
import AddToGroup from '../../../Components/Popup/AddToGroup.js'
import UsersPopup from '../../../Components/Popup/UsersPopup.js'
import Sidebar from '../../../Components/Sidebar/Index.js'
import Navbar from '../../../Components/Navbar/Index.js'
import LoaderInline from '../../../Components/Loader/LoaderInline.js'
import { AddIcon, CheckIcon } from '../../../Svg/Index.js'
import { SET_GUILD_FEED, LOAD_MORE_GUILD_FEED, JOIN_GUILD, LEAVE_GUILD } from '../../../Actions/Guilds'
import { SET_LIKES_POPUP_ACTIVE } from '../../../Actions/Sidebar'
import ProfileTrigger from '../../../Components/ProfileTrigger/Index.js'
import { MERCURE_URL } from '../../../config'
import LikesPopup from '../../../Components/Popup/LikesPopup.js'

class Feed extends Component {

    state = {
        sharePopupActive: false,
        usersPopupActive: false,
        likesPopupActive: false,
        threads: [],
        group: null,
        page: 1,
        isPaginating: false,
        isMember: (this.props.user.guilds && this.props.user.guilds.includes(this.props.guild.activeGuild._id)),
    }
 
    componentDidMount() {
        const { uuid } = this.props.match.params
        this.fetchFeed()
        this.eventSource = new EventSource(`${MERCURE_URL}?topic=https://jongenout.nl/guild/${uuid}/new`);
        this.eventSource.addEventListener('message', this.fetchFeed)
        document.body.classList.add('has-background');
        // this.props.actions.LOAD_MORE_GUILD_FEED(uuid, 1);

        document.querySelectorAll('.o-web-container')[0].addEventListener('scroll', this.loadMoreGuildFeed);
    }

    componentWillUnmount() {
        if(this.eventSource) {
		    this.eventSource.removeEventListener('message', this.handleMercure)
            this.eventSource.close();
        }
        document.body.classList.remove('has-background');
        document.querySelectorAll('.o-web-container')[0].removeEventListener('scroll', this.loadMoreGuildFeed);

    }
    
    loadMoreGuildFeed = () => {
        const { uuid } = this.props.match.params
        let element = document.querySelectorAll('.o-web-container')[0];
        if(!this.state.isPaginating) {
            if(this.props.guild.pagination.pagination_has_next_page && (element.scrollHeight - element.scrollTop < element.clientHeight + 800) ) {
                this.setState({ isPaginating: true, page: this.state.page+1 })
                this.props.actions.LOAD_MORE_GUILD_FEED(uuid, this.state.page).then(res => {
                    this.setState({ 
                        isPaginating: false,
                    })
                });
            }
        }
    }

    fetchFeed = () => {
        const { uuid } = this.props.match.params
        this.props.actions.SET_GUILD_FEED(uuid).then(res => {
            this.setState({threads: res})
        })
    }

    

    openSharePopup = () => {
        this.setState({
            sharePopupActive: true
        });
        document.body.classList.add('is-blurred');

    }

    closeSharePopup = () => {
        this.setState({
            sharePopupActive: false
        });
        document.body.classList.remove('is-blurred');

    }
    
    openUsersPopup = () => {
        this.setState({
            usersPopupActive: true
        });
        document.body.classList.add('is-blurred');

    }

    closeUsersPopup = () => {
        this.setState({
            usersPopupActive: false
        });
        document.body.classList.remove('is-blurred');

    }

    closeLikesPopup = () => {
        this.setState({
            likesPopupActive: false
        });
        this.props.actions.SET_LIKES_POPUP_ACTIVE(false)
        document.body.classList.remove('is-blurred');

    }

    handleJoin = (_id, group)=> {
        this.props.actions.JOIN_GUILD(_id).then(res => {
            this.setState({
                isMember: true
            })
     
        })
    }

    handleLeave = (_id)=> {
        this.props.actions.LEAVE_GUILD(_id).then(res => {
            this.setState({
                isMember: false
            })
        })
    }

    render() {
        const { user, guild } = this.props;
        const { sharePopupActive, usersPopupActive } = this.state;

        let isMember = false;

        if(user.guilds) {
            if(user.guilds.includes(guild.activeGuild._id)) {
                isMember = true;
            }
        }

        return (
            <>
                <div className="o-page-wrap">

                    <Sidebar />
                    <Navbar />
                    <ProfileTrigger />

                    <div className="o-main-container o-main-container--spacing">
                        
                        <div className={`js-fade-content ${sharePopupActive ? 'is-active' : ''} ${usersPopupActive ? 'is-active' : ''} ${this.props.sidebar.likes_popup_active ? 'is-active' : ''}`}>

                            {
                                guild.activeGuild && (
                                    <>
                                        <div className="c-group-header">
                                            <h1>{guild.activeGuild.title}</h1>
                                            <div className="c-group-users" onClick={this.openUsersPopup.bind(this)}>
                                                    <span className="c-group-count">{guild.activeGuild.user_count} leden</span>
                                                {
                                                     guild.activeGuild.users && (
                                                        guild.activeGuild.users.map((item, i) => 
                                                            <div className="c-group-user">
                                                                <div className="c-list-avatar c-list-avatar--alt" style={{backgroundImage: `url(${item.avatar.user_avatar})`}}>
                                                                </div>
                                                            </div>
                                                        )
                                                    )
                                                    
                                                }
                                                
                                            </div>
                                        </div>

                                        {
                                            this.state.isMember && (
                                                <button className="c-btn c-btn--primary-alt c-btn--compact-alt c-btn--shadowed c-btn--wide c-btn--join-guild c-btn--stretch" onClick={()=> this.handleLeave(guild.activeGuild._id)}>Je bent lid van deze groep&nbsp; <CheckIcon /></button>
                                            )
                                        }    

                                        {
                                            guild.threads && (
                                                <div className="c-feed">
                                                    {
                                                        guild.threads.map((item, i) => {
                                                            if(!!item.meeting) {
                                                                return (
                                                                    <CardMeeting 
                                                                        key={`meeting-wall-${i}`}
                                                                        users={item.meeting.user_count}
                                                                        date={item.meeting.date_for_humans}
                                                                        end_time={item.meeting.endTime}
                                                                        id={item.meeting._id}
                                                                        title={item.meeting.title}
                                                                        intro={item.meeting.intro}
                                                                        content={item.meeting.content}
                                                                        image={item.meeting.image}
                                                                        address={item.meeting.address}
                                                                    />
                                                                )
                                                            }

                                                            

                                                            return (
                                                                <Card 
                                                                    key={`wazzup-wall-${i}`}
                                                                    user={item.first_message.user}
                                                                    roles={item.first_message.user.roles}
                                                                    author={item.first_message.user.display_name}
                                                                    authorImage={item.first_message.user.avatar.user_avatar}
                                                                    createdAt={item.first_message.created_at_for_humans}
                                                                    body={item.first_message.body}
                                                                    image={item.first_message.image}
                                                                    messageCount={item.message_count}
                                                                    pinned={item.is_pinned}
                                                                    uuid={item._uuid}
                                                                    id={item._id}
                                                                    type="wazzup"
                                                                    enabled={this.state.isMember}
                                                                    isGroup
                                                                    like_count={item.like_count}
                                                                    showLikes={true}
                                                                />
                                                            )
                                                        }
                                                            
                                                        )
                                                    }    
                                                    
                                                    {
                                                        this.state.isPaginating && (
                                                            <LoaderInline />
                                                        )
                                                    }
                                                </div>
                                            )
                                        }

                                        {
                                            this.state.isMember && (
  
                                                <div className="o-main-container__center">
                                                    <button className="c-btn c-btn--primary c-btn--compact c-btn--bottom-float js-share-button" onClick={this.openSharePopup}>
                                                        <span className="c-btn__icon"><AddIcon /></span>Deel iets in deze groep
                                                    </button>
                                                </div>
                                                
                                            )
                                        }

                                        {
                                            !this.state.isMember && (
                                                <div className="o-main-container__center">
                                                    <button className="c-btn c-btn--primary c-btn--compact c-btn--bottom-float js-share-button" onClick={()=> this.handleJoin(guild.activeGuild._id, guild.activeGuild)}>
                                                        <span className="c-btn__icon"></span>Word lid van deze groep
                                                    </button>
                                                </div>
                                            )
                                        }
                                    </>
                                )
                            }
                            

                        </div>
                        {
                            sharePopupActive && (
                                <AddToGroup refresh={this.fetchFeed.bind(this)} uuid={this.props.match.params.uuid} closeSharePopup={this.closeSharePopup.bind(this)} author={user.avatar.user_avatar} />
                            )
                        }
                        {
                            usersPopupActive && (
                                <UsersPopup  closeUsersPopup={this.closeUsersPopup.bind(this)} />
                            )
                        }
                        {
                            this.props.sidebar.likes_popup_active && (
                                <LikesPopup closeLikesPopup={this.closeLikesPopup.bind(this)} />
                            )
                        }
                    </div>
                </div>
            </>
        )
    }
}
const mapStateToProps = state => {
    return {
        user: state.user.user,
        guild: state.guilds,
        sidebar: state.sidebar,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({SET_GUILD_FEED, LEAVE_GUILD, LOAD_MORE_GUILD_FEED, SET_LIKES_POPUP_ACTIVE, JOIN_GUILD }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Feed)